import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export function reviewNotesCountReducer(
	state = initialState.reviewNotesCount,
	action
) {
	switch (action.type) {
		case types.GET_REVIEWNOTES_COUNT: {
			return action.response;
		}
		case types.SELECT_ENGAGEMENT_USERROLE_ITEM: {
			return null;
		}
		default:
			return state;
	}
}

export function getReviewNotesAuthoredByCountReducer(
	state = initialState.reviewNotesAuthoredByCount,
	action
) {
	switch (action.type) {
		case types.GET_REVIEWNOTES_AUTHOREDBY_COUNT: {
			let reviewNotesAuthoredByCount = action.response;
			return reviewNotesAuthoredByCount;
		}
		case types.SELECT_ENGAGEMENT_USERROLE_ITEM: {
			return null;
		}
		default:
			return state;
	}
}
